export const WEEKDAY_LABELS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

export const BANK_EVENT_TYPES = {
  PAYMENT: "Pagamento de saldo",
  DISCOUNT: "Desconto de saldo",
  ADJUSTMENT: "Ajuste manual",
};

/**
 * Formata minutos como horas: 485 → "8h05". Sem sinal.
 */
export function formatMinutes(minutes) {
  if (minutes === null || minutes === undefined) return "-";
  const abs = Math.abs(Math.round(minutes));
  const hours = Math.floor(abs / 60);
  const mins = abs % 60;
  return `${hours}h${String(mins).padStart(2, "0")}`;
}

/**
 * Formata saldo com sinal: 30 → "+0h30", -90 → "-1h30", 0 → "0h00".
 */
export function formatBalance(minutes) {
  if (minutes === null || minutes === undefined) return "-";
  const rounded = Math.round(minutes);
  const sign = rounded > 0 ? "+" : rounded < 0 ? "-" : "";
  return `${sign}${formatMinutes(rounded)}`;
}

/**
 * 'YYYY-MM-DD' → 'DD/MM'
 */
export function shortDate(dateStr) {
  if (!dateStr) return "-";
  const [, month, day] = dateStr.split("-");
  return `${day}/${month}`;
}

/**
 * 'YYYY-MM-DD' → 'DD/MM/YYYY'
 */
export function fullDate(dateStr) {
  if (!dateStr) return "-";
  const [year, month, day] = dateStr.split("-");
  return `${day}/${month}/${year}`;
}

/**
 * Dia da semana (0=domingo) de uma data de calendário, sem interferência de fuso.
 */
export function weekdayOf(dateStr) {
  if (!dateStr) return null;
  return new Date(`${dateStr}T12:00:00Z`).getUTCDay();
}

/**
 * Texto de uma folga da empresa: "Folga: Aniversário" ou "Folga de 4h00: Ponte".
 */
export function dayOffLabel(name, hoursOff) {
  const description = name || "Folga da empresa";
  return hoursOff
    ? `Folga de ${formatMinutes(hoursOff * 60)}: ${description}`
    : `Folga: ${description}`;
}

/**
 * Máscara de hora enquanto digita: só dígitos, até 4, com ":" depois dos dois
 * primeiros ("805" → "80:5", "0805" → "08:05"). Não valida a faixa.
 */
export function maskClockTime(text) {
  const digits = String(text || "").replace(/\D/g, "").slice(0, 4);
  return digits.length > 2 ? `${digits.slice(0, 2)}:${digits.slice(2)}` : digits;
}

/**
 * "HH:MM" (00:00 a 23:59) → minutos desde a meia-noite; fora disso, null.
 */
export function parseClockTime(text) {
  const match = /^(\d{2}):(\d{2})$/.exec(String(text || "").trim());
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours > 23 || minutes > 59) return null;
  return hours * 60 + minutes;
}

/**
 * Data (Date, só o dia vale) + hora "HH:MM" no fuso local → Date. Hora
 * inválida ou sem data → null. É o mesmo instante que o <input
 * type="datetime-local"> dava com `new Date(valor)`.
 */
export function clockDateTime(date, time) {
  const minutes = parseClockTime(time);
  if (!date || minutes === null) return null;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), Math.floor(minutes / 60), minutes % 60);
}

/**
 * Data e hora de uma batida no fuso local: "15/10/2026" e "12:00".
 */
export function clockDateParts(value) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return { date: "-", time: "" };
  const pad = (n) => String(n).padStart(2, "0");
  return {
    date: `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`,
    time: `${pad(date.getHours())}:${pad(date.getMinutes())}`,
  };
}

/**
 * Data de hoje como 'YYYY-MM-DD' local (para o min de inputs type="date").
 */
export function todayDateInput() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
}

// A janela de competência por dia de fechamento saiu daqui para
// helpers/competencePeriod.js: os cronogramas de pagamento por hora usam a mesma
// conta, com o dia vindo do padrão de contrato em vez da empresa. Reexportado
// para não quebrar quem já importava de timeClock.
export {
  currentReference,
  addDays,
  lastDayOfMonth,
  closingDateOf,
  periodFromReference,
  periodFromCompetence,
  formatPeriodLabel,
  periodFileSuffix,
  closingDayLabel,
} from "./competencePeriod.js";
